import React from 'react';
import PropTypes from 'prop-types';

import OEToolbox from '../tools/oe-toolbox';

export default class ElementEventListenerAdapter extends React.Component {

    constructor(props) {
        super(props);

        this.mounted = false;
    }

    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }

    componentDidMount() {
        this.mounted = true;
        this.connect();
    }

    componentWillUnmount()    {
        this.release();
        this.mounted = false;
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.element !== this.props.element)   {
            this.reconnect(nextProps);
        } else if(!OEToolbox.shallowEqual(nextProps.events, this.props.events, true))   {
            this.reconnectListener(nextProps);
        }
    }

    connect(props) {
        if(!this.mounted || this.ref)    return;
        props = props || this.props;

        if(typeof(props.element) === 'string')  {
            this.ref = document.querySelector(props.element);
        } else if(props.element && typeof(props.element) === 'object')  {

            if(typeof(props.element.addEventListener) !== 'function' || typeof(props.element.removeEventListener) !== 'function')   {
                console.log('ElementEventListenerAdapter - could not connect to object without add/remove event interface.');
            } else {
                this.ref = props.element;
            }
        }

        if(!this.ref)   return;
        this.connectListener(props);
    }

    release()   {
        if(!this.ref) return;
        this.releaseListener();
        this.ref = undefined;
    }

    reconnect(props)    {
        this.release();
        this.connect(props);
    }

    connectListener(props)   {
        if(!this.mounted || !this.ref || Array.isArray(this.listener))    return;
        props = props || this.props;
        if(!Array.isArray(props.events))    return;

        this.listener = [];

        let connectEvent = function(name, fn)   {
            if(!name || typeof(name) !== 'string' || typeof(fn) !== 'function')   return;
            this.ref.addEventListener(name, fn);
            this.listener.push({name: name, fn: fn});
        }.bind(this);

        props.events.forEach(e => {
            if(typeof(e.fn) !== 'function')   return;

            if(Array.isArray(e.name))   {
                e.name.forEach(name => {
                    connectEvent(name, e.fn);
                })
            } else if(e.name || typeof(e.name) === 'string')   {
                connectEvent(e.name, e.fn);
            }
        });
    }

    releaseListener()  {
        if(!this.ref || !Array.isArray(this.listener))    return;

        this.listener.forEach(l => {
            this.ref.removeEventListener(l.name, l.fn);
        });

        this.listener = undefined;
    }

    reconnectListener(props)    {
        this.releaseListener();
        this.connectListener(props);
    }

    render() {
        return null;
    }
}

ElementEventListenerAdapter.defaultProps = {
    element: 'body'
};

ElementEventListenerAdapter.propTypes = {
    element: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    events: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
        fn: PropTypes.func.isRequired
    }))
};